import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { notification } from 'antd';

// services
import * as DashboardService from '../../../../services/bb-api/dashboards';

export const TopGroups: React.FC = () => {
  const [groupActivityData, setGroupActivityData] = useState<any[]>([]);

	const getData = useCallback(() => {
		try {
      DashboardService.topGroupsActivity().then(setGroupActivityData)
		} catch (error) {
			const message = 'Der skete en fejl';
			notification.error({ message });
		}
  }, [])
  
	useEffect(() => {
		getData();
		const intervalTime = 60 * 1000 // 1 min
		const intervalId = setInterval(getData, intervalTime)
		return () => clearInterval(intervalId)
	}, [getData]);


  return (
    <StyledContainer className='top-groups'>
      <h2>Top 3 aktive grupper</h2>
      <div className='container'>
        {groupActivityData.map((group) => (
          <div className='item'>
            <div className='group'>
              <img className='group-image' src={process.env.REACT_APP_GROUP_IMAGE_PATH + group.filename} />
              <div>
                <h4 className='group-title'>{group.name}</h4>
                <div className='data-container'>
                  <p>Opslag: <span className='number'>{group.num_posts}</span></p>
                  <p>Kommentarer: <span className='number'>{group.num_comments}</span></p>
                  <p>Likes: <span className='number'>{group.num_likes}</span></p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </StyledContainer>
  )
};

const StyledContainer = styled.div`
  h2, h4, p {
    color: #9ca3af;
  }

  h2 {
    text-align: center;
  }

  h4 {
    font-size: 1.5em;
  }

  p {
    font-size: 1.2em;
    margin: 0;
  }

  .container {
    background-color: #1f2937;
    box-shadow: #00000020 0px 2px 8px 0px;
    border-radius: 0.5em;
  }

  .item {
    display: flex;
    flex-direction: column;
    padding: 14px;
  }

  .item+.item {
    border-top: 1px solid #ffffff;
  }

  .group {
    display: flex;
    gap: 16px;
  }

  .group-image {
    width: 4vw;
    height: 4vw;
    border-radius: 50%;
    object-fit: cover;
    align-self: center;
  }

  .data-container {
    display: flex;
    gap: 50px;
  }

  .number {
    color: #ffffff;
  }
`